module.exports = __webpack_public_path__ + "img/talk_icon.5138ddf6.svg";